import React from 'react';
import { MaterialIcons } from '@iclinic/design-system';

import { buttonsTitle } from 'features/video-conference/constants';
import ToggleButton from 'features/video-conference/components/TeamComponents/ToggleButton';
import { setTelemedicineOptions } from 'features/video-conference/utils';
import { useChatContext } from 'features/video-conference/state/chatContext';
import { useAnnotationContext } from 'features/video-conference/state/annotationContext';
import { useConference } from 'features/video-conference/state/conferenceContext';

const { ContentPaste } = MaterialIcons;

export default function GoToMedicalRecordsButton() {
  const { setIsBackgroundSelectionOpen } = useConference();
  const { setIsChatWindowOpen } = useChatContext();
  const { setIsAnnotationWindowOpen } = useAnnotationContext();

  const handleClick = () => {
    setIsChatWindowOpen(false);
    setIsAnnotationWindowOpen(false);
    setIsBackgroundSelectionOpen(false);
    setTelemedicineOptions('iframe_status', 'minimize');
  };

  return (
    <ToggleButton
      onClick={handleClick}
      switchedOn
      variant="info"
      updateOn={false}
      title={buttonsTitle.MEDICAL_RECORDS}
      label={buttonsTitle.MEDICAL_RECORDS}
      icon={<ContentPaste />}
      aria-controls={buttonsTitle.MEDICAL_RECORDS}
      dataGa="minimize_telemedicine_iframe"
      dataSp="minimize_telemedicine_iframe"
    />
  );
}
